<template>
  <div>
    <!-- 资料/视频上传最终确定的通用弹窗 -->
    <el-dialog
      title="提示"
      top="calc(50vh -  82px)"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="dialogType !== 'uploadFail'"
      :before-close="handleClose"
      width="400px"
    >
      <div v-if="dialogType === 'uploadFail'">
        <p style="margin-bottom: 5px">
          共上传{{ errorObj.total }}个资料，{{
            errorObj.failCount
          }}个上传失败，请重新上传：
        </p>
        <p
          style="margin-bottom: 5px"
          v-for="(item, index) in errorObj.failList"
          :key="index"
        >
          · {{ item.fileName }}。
        </p>
      </div>
      <span v-else>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="dialogType === 'uploadFail'" @click="failToList"
          >取 消</el-button
        >

        <el-button v-else @click="closeDialog()">取 消</el-button>
        <el-button
          v-if="dialogType === 'uploadFail'"
          type="primary"
          @click="failToList"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="sureDialog()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebUploadTipDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: String,
      default: "",
    },
    dialogContent: {
      type: String,
      default: "",
    },
    errorObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  watch: {
    show: {
      handler: function (val) {
        this.dialogVisible = val;
      },
    },
  },

  mounted() {},

  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit("update:show", false);
    },
    handleClose(done) {
      done();
      this.closeDialog();
    },
    failToList() {
      this.$emit("toList");
    },
    sureDialog() {
      this.$emit("confirm");
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped></style>
